import React from "react";

function SpeakerIcon() {
  return (
    <svg
      width="11"
      height="16"
      viewBox="0 0 11 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.75 0.75L4.75 4.75H0.75V10.75H4.75L9.75 14.75V0.75Z"
        stroke="#039855"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SpeakerIcon;
